import { INTEGRATIONS_MAPPING } from 'lusha-integrations-widgets';
import { PLATFORMS } from '../../models/UserSettings/constants';
const LUSHA_INTEGRATIONS = {
    Salesforce: 'salesforce',
    SalesforceSandbox: 'sfSandbox',
    Hubspot: 'hubspot',
    Outreach: 'outreach',
    Lusha: 'lusha',
    Pipedrive: 'pipedrive',
    Salesloft: 'salesloft',
    Zoho: 'zoho',
    Bullhorn: 'bullhorn',
    Dynamics: 'dynamics',
};
const SUPPORTED_SEARCH_INDICATION_INTEGRATIONS = [
    LUSHA_INTEGRATIONS.Salesforce,
    LUSHA_INTEGRATIONS.SalesforceSandbox,
    LUSHA_INTEGRATIONS.Hubspot,
    LUSHA_INTEGRATIONS.Bullhorn,
];
const ENABLED_INTEGRATION_STATUS = 'enabled';
const isLushaLists = integrationKey => integrationKey === LUSHA_INTEGRATIONS.Lusha;
const getIntegrationDisplayName = integrationKey => { var _a; return isLushaLists(integrationKey) ? 'table' : (_a = INTEGRATIONS_MAPPING[integrationKey]) === null || _a === void 0 ? void 0 : _a.displayName; };
const getTextFieldWidthByPlatform = platform => {
    switch (platform) {
        case PLATFORMS.GMAIL:
            return '232';
        default:
            return null;
    }
};
const ONBOARDING_VIEWED_VARIABLE_NAME = '__ov';
export { ENABLED_INTEGRATION_STATUS, getIntegrationDisplayName, getTextFieldWidthByPlatform, isLushaLists, LUSHA_INTEGRATIONS, ONBOARDING_VIEWED_VARIABLE_NAME, SUPPORTED_SEARCH_INDICATION_INTEGRATIONS, };
